import { Component, Input } from '@angular/core';
import { SalvageTabContext } from '../salvage-tab-context';

@Component({
  selector: 'app-salvage-closed-tab',
  templateUrl: './salvage-closed-tab.component.html',
})
export class SalvageClosedTabComponent {
  @Input() context!: SalvageTabContext;
}
